/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 프로필 버튼 클래스를 정의한다.
 *
 * @file /src/components/button/Profile.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 5. 26.
 */
import * as parent from './Button';
import './Profile.css';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {}

export class Profile extends parent.Button {
    /**
     * 컴포넌트 확장타입
     */
    variant = 'profile';

    /**
     * 버튼 클래스를 정의한다.
     *
     * @param properties - 초기설정
     */
    constructor(public properties: Omit<Properties<Profile>, 'buttonClass' | 'toggle' | 'pressed'> = null) {
        super(properties);

        this.icon = this.properties.icon ?? null;
        this.text = this.properties.text ?? null;
        this.buttonClass = null;
        this.toggle = false;
        this.pressed = false;
    }
}
